<template>
  <div class="application-management">
    <template v-if="tableShow">
      <div class="nav">
        <div class="nav-right">
          <el-button type="primary" class="upload-btn" @click="createAppHandle">新建应用</el-button>
        </div>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading"
        @row-click="(row, column, event) => rowClick(row, column, event)"
      >
        <el-table-column label="名称">
          <template slot-scope="scope">
            <div class="title">
              <img :src="scope.row.square_logo_url" alt="#" class="table-img" />
              <span>{{ scope.row.agent_name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            <span>{{ scope.row.create_time }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="action">
              <el-button type="text" @click="() => actionFun({ action: '编辑', row: scope.row })">
                编辑
              </el-button>
              <el-button type="text" @click="() => showDelete(scope)">删除</el-button>
            </div>
          </template>
        </el-table-column>
        <div slot="empty"><NoData></NoData></div>
      </el-table>
      <el-pagination
        class="pagination"
        style="background-color: #ffffff"
        :current-page="tableCurPage"
        :total="tableTotal"
        @current-change="currentChangeFun"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="g_pageSizesConfig"
        :page-size="tablePageSize"
        @size-change="handleSizeChange"
      ></el-pagination>
    </template>
    <!-- 删除弹框 -->
    <el-dialog title="" :visible.sync="delDialogVisible" width="30%" center>
      <span>确定删除此应用吗?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="
            () => {
              delDialogVisible = false;
              actionFun({ action: '删除', row: rowTemp });
            }
          "
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
    <!-- 新建应用 -->
    <ConfigDialog
      config-name="createApp"
      :dialog-visible.sync="dialogShow"
      @dialogEmit="dialogEmit"
    ></ConfigDialog>
  </div>
</template>
<script>
import NoData from '@/components/no-data';
import ConfigDialog from '@/components/config-dialog';
import { EyaoSaasGetAppInfoList, EyaoSaasDeleteAppInfo } from '@/api/enterpriseWeChatManagement';
export default {
  name: 'ApplicationManagement',
  components: {
    NoData,
    ConfigDialog,
  },
  data() {
    return {
      // --------- 表格列表 ---------
      tableData: [], // 表格数据
      tableCurPage: 1, // 当前页
      tablePageSize: 10, // 每页条数
      tableTotal: 0, // 总条数
      loading: false, // 表格加载
      // --------- 组件状态 ---------
      tableShow: true, // 是否显示表格列表
      dialogShow: false, // 是否显示新建弹窗组件
      // 暂存数据
      rowTemp: {}, // 暂存row数据(如删除操作)
      delDialogVisible: false, // 删除弹窗
    };
  },
  created() {
    this.tablePageSize = this.g_pageSizeDefault;
    this.init();
  },
  mounted() {},
  methods: {
    // 初始化
    init() {
      this.getTaleData();
    },
    // 查询列表
    async getTaleData(
      query = {
        page_index: this.tableCurPage,
        page_size: this.tablePageSize,
      },
    ) {
      this.loading = true;
      try {
        const res = await EyaoSaasGetAppInfoList({
          page_index: query.page_index,
          page_size: query.page_size,
        });
        this.tableData = res.list;
        this.tableTotal = res.total;
      } catch (error) {
        this.$message.error(error.message);
      }
      this.loading = false;
    },
    // 分页
    currentChangeFun(e) {
      this.tableCurPage = e;
      this.getTaleData();
    },
    // 切换每页显示条目个数
    handleSizeChange(e) {
      this.tablePageSize = e;
      this.getTaleData();
    },
    /** 表格操作
     * @description: 表格操作事件
     * @param {string} action 操作名称
     * @param {object} row 操作行数据
     * @return {*} void
     */
    async actionFun({ action, row }) {
      switch (action) {
        case '编辑':
          this.g_tourl(
            `/saas/applicationManagement/applicationDetail.html?agent_id=${row.agent_id}`,
          );
          break;
        case '删除':
          // 保存/删除=>重新请求数据
          this.loading = true;
          try {
            const res = await EyaoSaasDeleteAppInfo({
              agent_id: row.agent_id,
            });
            if (res) {
              this.getTaleData();
              this.$message.success('删除成功');
            }
          } catch (error) {
            this.$message.error(error.message);
          }
          this.loading = true;
          break;
        default:
          break;
      }
    },
    // 打开创建应用组件
    createAppHandle() {
      this.tableShow = true;
      this.dialogShow = true;
    },
    // 新建保存回调
    dialogEmit() {
      this.tableCurPage = 1;
      this.getTaleData();
    },
    // 显示删除弹窗
    showDelete(scope) {
      this.delDialogVisible = true;
      this.rowTemp = scope.row;
    },
    // 整行点击
    rowClick(row, column, event) {
      console.log(row, column, event);
    },
  },
};
</script>
<style lang="scss" scoped>
.application-management {
  // 条件栏
  .nav {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .nav-left {
      .img-text {
        font-size: 16px;
        color: #313233;
      }
    }
    .nav-right {
      display: flex;
      .search-input {
        width: inherit !important;
        height: 48px;
        margin-right: 30px;
      }
    }
  }

  // 表格----------------
  // 标题
  .title {
    display: flex;
    align-items: center;
    .table-img {
      width: 80px;
      height: 80px;
      margin-right: 15px;
      border-radius: 4px;
      object-fit: cover;
    }
  }
  // 操作
  .action {
    a {
      text-decoration: none;
      color: #2f96ff;
      margin-right: 5px;
    }
  }

  .pagination {
    margin-top: 12px;
    text-align: right;
  }
}
</style>
